<script lang="ts">
    import { urlsBuilderContextToken } from "@/context_tokens";
    import { getTypedContext } from "@lib/svelte-typed-context";

    import Button from "@components/Buttons/Button.svelte";
    import T from "@components/T.svelte";

    const urlsBuilder = getTypedContext(urlsBuilderContextToken);
</script>

<Button
    size="large"
    variant="opacityOnHover"
    url={urlsBuilder.createLoginUrl()}
>
    <T namespace="reviews.ReviewsFormModalWidget" translationKey="sign_in" />
</Button>
